<main-spinner-cmp></main-spinner-cmp>
<overlay></overlay>
<div id="content" [@routeAnimation]="prepRouteState(routerOutlet)" >
    <router-outlet #routerOutlet="outlet"></router-outlet>
</div>

